import {Component, ViewChild} from '@angular/core';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @ViewChild('nav') nav;
  constructor(){}

  click():void {
    console.log(this.nav.nativeElement.classList)
    this.nav.nativeElement.classList.contains('show') ?this.nav.nativeElement.classList.remove('show') : this.nav.nativeElement.classList.add('show');

  }
}
